import React from 'react'
import type { Moment } from 'moment'
import { connect } from 'react-redux'

import { hideModal, showModal } from '../../store/modal'
import { selectDay } from '../../store/queueTimes'
import type { QueueTimesApiDayData } from '../../store/queueTimes'
import QueueTimesDay from './Day'

type TimesByDay = Record<string, QueueTimesApiDayData | undefined>

type QueueTimesStoreState = {
  queueTimes: {
    day: Moment
    timesByDay: TimesByDay
  }
}

type QueueTimesProps = {
  day: Moment
  timesByDay: TimesByDay
  showModal: typeof showModal
  hideModal: typeof hideModal
  selectDay: typeof selectDay
}

const mapStateToProps = (state: QueueTimesStoreState) => ({
  day: state.queueTimes.day,
  timesByDay: state.queueTimes.timesByDay,
})

const mapDispatchToProps = {
  showModal,
  hideModal,
  selectDay,
}

const renderDays = (day: Moment, timesByDay: TimesByDay) => {
  const days = []
  for (let i = -1; i < 2; i++) {
    const date = day.clone().add(i, 'day')
    days.push(
      <div
        className={
          'QueueTimesElement__Day ' +
          (i === 0 ? 'QueueTimesElement__Day--current' : '')
        }
        key={i}
      >
        <QueueTimesDay
          date={date}
          times={timesByDay[date.format('YYYY-MM-DD')]}
        />
      </div>,
    )
  }
  return days
}

function QueueTimes({
  day,
  selectDay,
  showModal,
  hideModal,
  timesByDay,
}: QueueTimesProps) {
  const timesForToday = timesByDay[day.format('YYYY-MM-DD')]

  let adviceHeadline = ''
  let adviceGettingCrowded = ''
  let adviceEarlyBird = ''
  let adviceBestTime = ''
  let adviceGeneral = ''

  if (timesForToday) {
    adviceHeadline = 'Unsere Tipps für Besuchszeiten'
    adviceGettingCrowded = `Ab ca. ${timesForToday.waitingTime.from} Uhr muss mit Wartezeiten gerechnet werden.`
    adviceEarlyBird = `Kommen Sie gleich um ${timesForToday.openingTime.from} Uhr, dann ist die Ausstellung noch ganz leer.`
    adviceBestTime = `Kommen Sie ab ${timesForToday.bestTime} Uhr, dann wird es von Minute zu Minute leerer und immer schöner.`
    adviceGeneral =
      'Wartezeiten sind vom Wetter abhängig. Die o.g. Wartezeiten gelten bei mittlerem Wetter. Bei Regen gibt es eventuell noch stärkere Wartezeiten. Bei gutem Wetter kommt es teilweise zu kürzeren Wartezeiten'

    if (window.jsProps.lang === 'en') {
      adviceHeadline = 'Our tips for visiting times'
      adviceGettingCrowded = `From ${timesForToday.waitingTime.from} you can expect to queue.`
      adviceEarlyBird = `We suggest you come at ${timesForToday.openingTime.from}, when the exhibition is still empty.`
      adviceBestTime = `Come after ${timesForToday.bestTime}, when there will be fewer visitors to the exhibition and you will enjoy your visit so much more.`
      adviceGeneral =
        'The queue depends a lot on weather conditions. The above mentioned queue is valid for average weather. When it´s raining the waiting time may be longer. If the weather is fine, the queue is usually shorter.'
    }
  }

  return (
    <div className="QueueTimesElement">
      <div className="QueueTimesElement__Box">
        <div className="QueueTimesElement__DayNav">
          <button
            className="QueueTimesElement__DayNavButton QueueTimesElement__DayNavButton--left"
            onClick={() => selectDay(day.clone().subtract(1, 'day'))}
          >
            {window.jsProps.strings.previousDay}
          </button>

          <div className="QueueTimesElement__DayNavSelectContainer">
            <div
              className="QueueTimesElement__DayNavSelect"
              onClick={() =>
                showModal('DatePickerModal', {
                  date: day,
                  onChange: (date) => {
                    selectDay(date)
                    hideModal()
                  },
                })
              }
            >
              {window.jsProps.strings.queueTimesPrediction}
            </div>
          </div>

          <button
            className="QueueTimesElement__DayNavButton QueueTimesElement__DayNavButton--right"
            onClick={() => selectDay(day.clone().add(1, 'day'))}
          >
            {window.jsProps.strings.nextDay}
          </button>
        </div>

        <div className="QueueTimesElement__Days">
          {renderDays(day, timesByDay)}
        </div>
      </div>

      {timesForToday && (
        <div className="QueueTimesElement__Advice">
          <div className="row">
            <div className="col-md-offset-1 col-md-10">
              <h2 className="Headline Headline--H2 Headline--bold">
                {adviceHeadline}
              </h2>
              <div className="QueueTimesElement__AdviceText Text">
                <p>
                  <strong>{adviceGettingCrowded}</strong>
                </p>
                <ul>
                  <li>{adviceEarlyBird}</li>
                  <li>{adviceBestTime}</li>
                </ul>
                <p>{adviceGeneral}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(QueueTimes)
